import { isoDateTime, z } from "../zod.js";

// Operational liveness/readiness surface (ALB target checks, spec 15's per-tenant
// canary hits the web origin; this is the API's own probe). Not a product feature.
export const HealthStatus = z
  .object({
    status: z.enum(["ok", "degraded"]),
    version: z.string().openapi({ example: "0.0.0" }),
    region: z.string().openapi({ example: "ap-southeast-1" }),
    time: isoDateTime(),
  })
  .openapi("HealthStatus");

export type HealthStatus = z.infer<typeof HealthStatus>;
